import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { dynamicElementsBadgeKey } from '@epicuro-next/constants/dynamic-elements';
import { DynamicElementsTooltipDirective } from '@epicuro-next/dynamic-elements/dynamic-tooltip';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { AnimationProp } from '@fortawesome/angular-fontawesome';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

@DynamicComponentRegister(dynamicElementsBadgeKey)
@Component({
  selector: 'atx-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IconsModule],
  hostDirectives: [
    {
      directive: DynamicElementsTooltipDirective,
      // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
      inputs: ['tooltip', 'tooltipPlacement'],
    },
  ],
})
export class BadgeComponent {
  @Input() public icon: IconProp;
  @Input() public label = '';
  @Input() public title = '';
  @Input() public size: SizeProp = 'xs';
  @Input() public iconAnimation: AnimationProp;
}

DontTreeShake(BadgeComponent);
